import { createContext, useEffect, useState } from 'react';

import { ThemeColorScheme } from './types';

export type IThemeContext = {
  themeMode: ThemeColorScheme;
  toggleThemeMode: () => void;
  setTheme: (theme: ThemeColorScheme) => void;
};

export const ThemeContext = createContext<IThemeContext>({
  themeMode: 'light',
  toggleThemeMode: () => {
    throw new Error('No theme context provider');
  },
  setTheme: () => {
    throw new Error('No theme context provider');
  },
});

export const ThemeContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [themeMode, setThemeMode] = useState<ThemeColorScheme>('dark');

  useEffect(() => {
    const storedThemeMode = localStorage.getItem('kawaak_theme_v1');
    if (storedThemeMode) setThemeMode(storedThemeMode as ThemeColorScheme);
  }, []);

  const toggleThemeMode = () => {
    const newThemeMode = themeMode === 'light' ? 'dark' : 'light';
    setThemeMode(newThemeMode);
    localStorage.setItem('kawaak_theme_v1', newThemeMode);
  };

  const setTheme = (theme: ThemeColorScheme) => {
    setThemeMode(theme);
    localStorage.setItem('kawaak_theme_v1', theme);
  };

  const memoizedValue: IThemeContext = {
    themeMode,
    toggleThemeMode,
    setTheme,
  };

  return (
    <ThemeContext.Provider value={memoizedValue}>
      {children}
    </ThemeContext.Provider>
  );
};
